export const CATEGORY_LABEL = {
  onboarding: "Onboarding",
  in_service: "Compensation & In-Service",
  compliance: "Compliance",
  exit: "Exit & Separation",
  other: "Other",
};

export const STATUS_LABEL = {
  draft: { label: "DRAFT", cls: "bg-zinc-100 text-zinc-700" },
  pending_employee: { label: "AWAITING EMPLOYEE", cls: "bg-amber-100 text-amber-800" },
  pending_hr: { label: "AWAITING HR", cls: "bg-sky-100 text-sky-800" },
  completed: { label: "COMPLETED", cls: "bg-emerald-100 text-emerald-800" },
  rejected: { label: "REJECTED", cls: "bg-rose-100 text-rose-800" },
};

// Number → Indian-English words (up to 99 crore). Used to auto-populate
// `ctc_words` / `new_ctc_words` whenever the user updates CTC (per month)
// in an Offer / Appointment / Increment letter.
export function _numToIndianWords(n) {
  n = Math.max(0, Math.round(Number(n) || 0));
  if (n === 0) return "Zero Only";
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  const twoDigits = (x) => x < 20 ? ones[x] : `${tens[Math.floor(x / 10)]}${x % 10 ? " " + ones[x % 10] : ""}`;
  const threeDigits = (x) => {
    const h = Math.floor(x / 100), r = x % 100;
    return `${h ? ones[h] + " Hundred" + (r ? " " : "") : ""}${r ? twoDigits(r) : ""}`;
  };
  const parts = [];
  const crore = Math.floor(n / 10000000); n %= 10000000;
  const lakh  = Math.floor(n / 100000);   n %= 100000;
  const thou  = Math.floor(n / 1000);     n %= 1000;
  const rest  = n;
  if (crore) parts.push(`${twoDigits(crore)} Crore`);
  if (lakh)  parts.push(`${twoDigits(lakh)} Lakh`);
  if (thou)  parts.push(`${twoDigits(thou)} Thousand`);
  if (rest)  parts.push(threeDigits(rest));
  return parts.join(" ").replace(/\s+/g, " ").trim() + " Only";
}
